import { Permission } from '@/lib/permissions/v1'
import { logParamKey, Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'created_at',
        direction: 'desc',
    })

    route.setLimit(40)
}

export enum AdminLogsRouteName {
    Index = 'admin.log.index',
    Details = 'admin.log.details',
}

export default {
    path: 'logs',
    component: () => import('@/views/admin/Index.vue'),
    meta: {
        label: 'Logs',
        auth: true,
    },
    children: [
        {
            path: '',
            name: AdminLogsRouteName.Index,
            component: () => import('@/views/admin/logs/Index.vue'),
            meta: {
                label: 'Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
        },
        {
            path: `:${logParamKey}/details`,
            name: AdminLogsRouteName.Details,
            component: () => import('@/views/admin/logs/Index.vue'),
            meta: {
                label: 'Log Details',
                auth: true,
                permission: Permission.EventView,
            },
        },
    ],
}
